export default __webpack_public_path__ + "static/media/menu-video-active.6463e162.svg";